import React from 'react';

import { Stack } from '@atlaskit/primitives/compiled';

import type { AudioFeature } from '../../../types/audioFeature';

import { AudioFeatureToggle } from './AudioFeatureToggle';
import { AudioHeader } from './AudioHeader';

export type AudioHeaderPanelProps = {
	featureList: AudioFeature[];
	activeFeature: AudioFeature;
	setActiveFeature: (feature: AudioFeature) => void;
};

export const AudioHeaderPanel = ({
	featureList,
	activeFeature,
	setActiveFeature,
}: AudioHeaderPanelProps) => {
	const getNextFeature = () => {
		const currentIndex = featureList.findIndex((feature) => feature.name === activeFeature.name);
		const nextIndex = (currentIndex + 1) % featureList.length;
		return featureList[nextIndex];
	};

	return (
		<Stack space="space.250" alignInline="center">
			<AudioHeader featureList={featureList} activeFeature={activeFeature} />
			<AudioFeatureToggle
				featureList={featureList}
				activeFeature={activeFeature}
				onClick={() => setActiveFeature(getNextFeature())}
			/>
		</Stack>
	);
};
